import { chakra, Flex, IconButton, Input } from "@chakra-ui/react";

export const TopHeaderContainer = chakra(Flex, {
  baseStyle: {
    w: "100%",
    px: "4",
    py: "2",
    align: "center",
    justify: "space-between",
    borderBottom: "1px solid",
    borderColor: "gray.200",
    bg: "white",
  },
});

export const BellIconButton = chakra(IconButton, {
  baseStyle: {
    width: "25px",
    variant: "ghost",
    fontSize: "20px",
    bg: "white",
  },
});

export const UserSearch = chakra(Input, {
  baseStyle: {
    borderRadius: "md",
    pl: "2.3rem",
    bg: "gray.50",
  },
});
